// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vygy","label":"styles_label__3hWeI"};